import { useContext } from 'react';

import { ChartLayoutRatioContext } from '../context/ChartLayoutRatio.context.js';

/**
 * @internal
 */
export const useChartLayoutRatio = () => useContext(ChartLayoutRatioContext);
